import React from 'react';
export default function FireTrailSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="pet-svg">
      <style>{`
        @keyframes ft-flicker1 {
          0% { transform: translateY(0) scaleX(1) scaleY(1); opacity: 0.9; }
          25% { transform: translateY(-4px) scaleX(0.85) scaleY(1.1); opacity: 1; }
          50% { transform: translateY(-10px) scaleX(1.1) scaleY(0.9); opacity: 0.7; }
          75% { transform: translateY(-16px) scaleX(0.75) scaleY(1.05); opacity: 0.4; }
          100% { transform: translateY(-22px) scaleX(0.5) scaleY(0.7); opacity: 0; }
        }
        @keyframes ft-flicker2 {
          0% { transform: translateY(0) scaleX(1) scaleY(1); opacity: 0.85; }
          25% { transform: translateY(-3px) scaleX(1.1) scaleY(1.05); opacity: 0.95; }
          50% { transform: translateY(-8px) scaleX(0.8) scaleY(1.1); opacity: 0.65; }
          75% { transform: translateY(-14px) scaleX(1.05) scaleY(0.85); opacity: 0.3; }
          100% { transform: translateY(-20px) scaleX(0.6) scaleY(0.6); opacity: 0; }
        }
        @keyframes ft-flicker3 {
          0% { transform: translateY(0) scaleX(1) scaleY(1); opacity: 0.8; }
          30% { transform: translateY(-5px) scaleX(0.9) scaleY(1.15); opacity: 0.9; }
          60% { transform: translateY(-12px) scaleX(1.15) scaleY(0.85); opacity: 0.5; }
          100% { transform: translateY(-18px) scaleX(0.55) scaleY(0.65); opacity: 0; }
        }
        @keyframes ft-waver {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-1.5px); }
          75% { transform: translateX(1.5px); }
        }
        .ft-f1 { animation: ft-flicker1 1.6s ease-out infinite; }
        .ft-f2 { animation: ft-flicker2 2.0s ease-out infinite 0.4s; }
        .ft-f3 { animation: ft-flicker3 1.8s ease-out infinite 0.8s; }
        .ft-f4 { animation: ft-flicker1 2.2s ease-out infinite 1.2s; }
        .ft-waver { animation: ft-waver 0.8s ease-in-out infinite; }
      `}</style>
      <defs>
        <linearGradient id="ftFlame1" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#FF3D00" />
          <stop offset="40%" stopColor="#FF9100" />
          <stop offset="80%" stopColor="#FFEA00" />
          <stop offset="100%" stopColor="#FFF9C4" />
        </linearGradient>
        <linearGradient id="ftFlame2" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#D50000" />
          <stop offset="50%" stopColor="#FF6D00" />
          <stop offset="100%" stopColor="#FFD600" />
        </linearGradient>
        <linearGradient id="ftFlame3" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0%" stopColor="#E65100" />
          <stop offset="60%" stopColor="#FFB300" />
          <stop offset="100%" stopColor="#FFFDE7" />
        </linearGradient>
        <radialGradient id="ftGlow" cx="0.5" cy="0.7" r="0.5">
          <stop offset="0%" stopColor="#FF6D00" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#FF6D00" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Ambient glow */}
      <ellipse cx="20" cy="34" rx="12" ry="6" fill="url(#ftGlow)" />

      <g className="ft-waver">
        {/* Flame 1 - center, large */}
        <g className="ft-f1" style={{ transformOrigin: '20px 38px' }}>
          <path d="M20 38C20 38 14 32 14 28C14 24 17 22 20 18C23 22 26 24 26 28C26 32 20 38 20 38Z"
            fill="url(#ftFlame1)" />
          <path d="M20 38C20 38 17 34 17 31C17 28 18.5 26 20 24C21.5 26 23 28 23 31C23 34 20 38 20 38Z"
            fill="white" opacity="0.25" />
        </g>

        {/* Flame 2 - left, medium */}
        <g className="ft-f2" style={{ transformOrigin: '12px 38px' }}>
          <path d="M12 38C12 38 8 34 8 31C8 28.5 10 27 12 24.5C14 27 16 28.5 16 31C16 34 12 38 12 38Z"
            fill="url(#ftFlame2)" />
        </g>

        {/* Flame 3 - right, medium */}
        <g className="ft-f3" style={{ transformOrigin: '28px 38px' }}>
          <path d="M28 38C28 38 24.5 34.5 24.5 32C24.5 29.5 26 28 28 25.5C30 28 31.5 29.5 31.5 32C31.5 34.5 28 38 28 38Z"
            fill="url(#ftFlame3)" />
        </g>

        {/* Flame 4 - small accent, center-right */}
        <g className="ft-f4" style={{ transformOrigin: '24px 38px' }}>
          <path d="M24 38C24 38 22 36 22 34.5C22 33 23 32.5 24 31C25 32.5 26 33 26 34.5C26 36 24 38 24 38Z"
            fill="#FFD600" opacity="0.8" />
        </g>
      </g>

      {/* Ember sparks */}
      <circle cx="16" cy="26" r="0.7" fill="#FFAB00">
        <animate attributeName="opacity" values="0;0.9;0" dur="1.2s" repeatCount="indefinite" />
        <animate attributeName="cy" values="26;18" dur="1.2s" repeatCount="indefinite" />
      </circle>
      <circle cx="25" cy="24" r="0.5" fill="#FF6D00">
        <animate attributeName="opacity" values="0;0.8;0" dur="1.5s" repeatCount="indefinite" begin="0.6s" />
        <animate attributeName="cy" values="24;16" dur="1.5s" repeatCount="indefinite" begin="0.6s" />
      </circle>
    </svg>
  );
}
